import React, { useEffect, useState } from 'react'

import './styles.scss'

const AnswerCircle = ({ answer, circleStyle, onSelectAnswer }) => {
	const [windowWidth, setWindowWidth] = useState(window.innerWidth)
	const [isSelected, setIsSelected] = useState(false)

	useEffect(() => {
		const resizeHandler = () => {
			setWindowWidth(window.innerWidth)
		}
		window.addEventListener('resize', resizeHandler)

		return () => {
			window.removeEventListener('resize', resizeHandler)
		}
	}, [window.innerWidth])

	return (
		<div
			className={`circle-answer-wrapper ${isSelected ? 'selected' : ''}`}
			style={
				windowWidth > 385
					? circleStyle
					: windowWidth > 354
					? {
							...circleStyle,
							left: circleStyle.left - 10,
					  }
					: windowWidth > 333
					? {
							...circleStyle,
							left: circleStyle.left - 25,
					  }
					: {
							...circleStyle,
							left: circleStyle.left - 35,
					  }
			}
		>
			<div
				className={`circle-answer ${isSelected ? 'selected' : ''}`}
				onClick={() => {
					setIsSelected(!isSelected)
					onSelectAnswer()
				}}
			>
				<span className="circle-answer-text">{answer}</span>
			</div>
		</div>
	)
}

export { AnswerCircle }
